/**********************************************************
Alexander Self
8/22/17
Gang builder container: manages the routes and components
**********************************************************/
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { MECH_HARVEST_URLS } from '../constants';
import Tabs from '../components/tabs';


class Harvest extends Component {
  componentDidMount() {
    document.title = 'Harvest';
  }
  render() {
    return (
      <div>
        <div className="row">
          <h5>Harvest <span className="flow-text right">{ moment().format("dddd, MMMM Do YYYY") }</span></h5><hr />
          <Tabs id={"mechHarvest"} tabs={MECH_HARVEST_URLS} level={this.props.user.level} />
        </div>
        <div>
          { this.props.children }
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    user: state.auth.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({

  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(Harvest);



/* END */



// WEBPACK FOOTER //
// ./src/containers/harvest.js